var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center gap-2",class:{ 'w-full': _vm.label }},[_c('label',{staticClass:"relative inline-block w-12 h-6 gd-toggle-switch",class:{ active: _vm.value, 'opacity-50 cursor-not-allowed': _vm.disabled, 'cursor-pointer': !_vm.disabled},on:{"click":_vm.toggle}},[_c('span',{staticClass:"absolute inset-0 rounded-full",class:{
        'bg-primary': _vm.value,
        [_vm.bgClass]: !_vm.value,
      }})]),(_vm.label)?_c('span',{class:_vm.labelClass || 'text-white'},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }